import { useEffect } from 'react'
import axios from 'axios'
import { getAccessToken, getPermission } from '../services/Firebase'
import Configuration from '../services/api/Configuration'
import CookiesStorageService from '../services/CookiesStorageService'

const useGetNotificationTokenAndSendToBackend = () => {
  const api = Configuration.Notification_Endpoints

  const getAndSendAccessToken = async () => {
    const token = await getAccessToken()

    await axios.put(`${Configuration.REACT_APP_BFF_BASE_URL}/${api.notificationsSendRegistrationToken}`, {
      notify_token: token,
      source: 'UM',
      user_id: CookiesStorageService.getUserId(),
    })
  }

  useEffect(() => {
    getPermission()
    getAndSendAccessToken()
  }, [])
}

export default useGetNotificationTokenAndSendToBackend
